export default {
  getContractSectionLineItem: (state) => state.contractSectionLineItem,
};
